// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e916587a","455":"55f321f7","977":"684305f7"}[chunkId] + ".chunk.js";
};